import { useFormContext, useWatch } from 'react-hook-form';

import { type PriceFormValues } from '@eduzz-product-manager/validators';

import { MoneyInputMask } from '@/components/form/MoneyInputMask';
import { useZustandSync } from '@/hooks/useZustandSync';

import { PaymentTaxes } from './PaymentTaxes';

export const OneTime = () => {
  const form = useFormContext<PriceFormValues>();

  useZustandSync<PriceFormValues>(form.control, (data, current) => ({
    payment: {
      ...current.payment,
      price: data.price || 0
    }
  }));

  const price = useWatch({
    control: form.control,
    name: 'price'
  })!;

  const youReceive = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  }).format(Math.max(0, price - price * 0.049 - 2.49));

  return (
    <div className='pt-4'>
      <MoneyInputMask id='product-price' placeholder='Preço do produto' name='price' prefix='R$' />

      <div className='flex gap-2 text-base'>
        Você recebe: <p className='font-bold'>{youReceive}</p>
      </div>

      <PaymentTaxes />
    </div>
  );
};
